export default defineNuxtPlugin(() => {
  // This plugin runs only on the client side
  if (process.client) {
    // Add any client-specific initialization here
    console.log('Client-side initialization complete')
    
    // Ensure AOS is properly initialized after hydration
    if (typeof window !== 'undefined') {
      const initAOSAfterHydration = () => {
        if (window.AOS) {
          window.AOS.refresh()
        }
      }
      
      // Wait for hydration to complete
      setTimeout(initAOSAfterHydration, 100)
    }
  }
}) 